import { Divider as DividerChakra } from "@chakra-ui/react"

type DividerProps = {
    orientation?: "horizontal" | "vertical";
    width?: string;
}

const Divider = ({ orientation = "horizontal", width }: DividerProps) => {
    return (
        <DividerChakra
            height={orientation === 'horizontal' ? "2px" : '40px'}
            width={orientation === 'vertical' ? "2px" : width || '100%'}
            orientation={orientation}
            backgroundColor="#D9D9D9"
            boxShadow="0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)" />
    )
  };

  export { Divider };